import { createAsyncThunk } from "@reduxjs/toolkit";
import { analyticsApi } from "../api/analytics.api";
import {
  analyticsLoaded,
  analyticsRequestFailed,
  analyticsRequestStarted,
} from "./analytics.slice";

function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  return "Something went wrong";
}

export const fetchAnalytics = createAsyncThunk(
  "analytics/fetch",
  async (teamId: string | void, { dispatch }) => {
    dispatch(analyticsRequestStarted());
    try {
      const [summary, byTeam] = await Promise.all([
        analyticsApi.summary(teamId || undefined),
        analyticsApi.byTeam(),
      ]);
      dispatch(analyticsLoaded({ summary, byTeam }));
    } catch (err) {
      dispatch(analyticsRequestFailed(errorMessage(err)));
      throw err;
    }
  },
);
